






















































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { DataOptions, DataTableHeader } from "vuetify";
import {
  GetLocationResponse,
  GetUnitResponse,
  LocationModel,
  LocationsApi,
  UnitsApi,
  VariableModel,
  VariablesApi,
} from "../../../apis";
import { IAction } from "../common/CommonTypes";
import MoreVertBtn from "../common/MoreVertBtn.vue";
import { ACTION } from "./";
import VariableUnitDialog from "./VariableUnitDialog.vue";
import VariableDialog from "./VariableDialog.vue";

@Component({
  components: { MoreVertBtn, VariableUnitDialog, VariableDialog },
})
export default class VariableUnit extends Vue {
  showVariableDetailDialog = false;
  showDeleteVariableDialog = false;
  showEditVariableDialog = false;
  showRecommendedAction = false;
  searchForm = {
    keyword: "",
    type: "",
  };
  selectedVariables: VariableModel[] = [];
  mode: ACTION = null;
  locationDetailResponse: LocationModel = null;
  variables: VariableModel[] = [];
  selectedRow: VariableModel = null;
  selectedVariable: VariableModel = null;
  pagingOption: DataOptions | null = null;
  totalItems = 0;
  getLocationResponse: GetLocationResponse = null;
  getUnitResponse: GetUnitResponse = null;

  get actions(): Array<IAction> {
    return [
      {
        titleName: this.$t("text.edit"),
        action: ACTION.EDIT_VARIABLE,
        permission: { context: "VARIABLES_MANAGEMENT", action: "update" },
      },
      {
        titleName: this.$t("text.delete"),
        action: ACTION.DELETE_VARIABLE,
        titleStyle: "color: red",
        permission: { context: "VARIABLES_MANAGEMENT", action: "delete" },
      },
    ];
  }

  get TYPES() {
    return [
      { text: "Bool", value: "BOOL" },
      { text: "Byte", value: "BYTE" },
      { text: "UByte", value: "UBYTE" },
      { text: "Word", value: "WORD" },
      { text: "Floating", value: "FLOATING" },
      { text: "Time", value: "TIME" },
    ];
  }

  get ICONS() {
    return [
      { id: 1, text: "O2 Down", value: "O2_DOWN" },
      { id: 2, text: "Flushing", value: "FLUSHING" },
      { id: 3, text: "Pulldown", value: "PULLDOWN" },
      { id: 4, text: "O2 Up", value: "O2_UP" },
      { id: 5, text: "Ventilator", value: "VENTILATOR" },
      { id: 6, text: "Heater", value: "HEATER" },
      { id: 7, text: "Humidifier", value: "HUMIDIFIER" },
      { id: 8, text: "Dehumidification", value: "DEHUMIDIFICATION" },
      { id: 9, text: "Overflow (give)", value: "OVERFLOW_GIVE" },
      { id: 10, text: "Overflow (receive)", value: "OVERFLOW_RECEIVE" },
      { id: 11, text: "Air compressor", value: "AIR_COMPRESSOR" },
      { id: 12, text: "N2 generator", value: "N2_GENERATOR" },
      { id: 13, text: "Green Light", value: "GREEN_LIGHT" },
      { id: 14, text: "Red Light", value: "RED_LIGHT" },
      { id: 15, text: "Tempt Up", value: "TEMPT_UP" },
      { id: 16, text: "Temp Down", value: "TEMP_DOWN" },
    ];
  }

  get CHECKBOXES() {
    return [
      {
        text: this.$t("text.alarm"),
        value: "alarm",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.startStop"),
        value: "startStop",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.o2Up"),
        value: "o2Up",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.remainingO2DownTime"),
        value: "remainingO2DownTime",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.greenButton"),
        value: "greenButton",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.home"),
        value: "home",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.status"),
        value: "status",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.parameter"),
        value: "parameter",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.calibrationParameter"),
        value: "calibrationParameter",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.readonly"),
        value: "readOnly",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.operationTime"),
        value: "operationTime",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.inProgress"),
        value: "inProgress",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.recordData"),
        value: "recordData",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.graph"),
        value: "graph",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
    ] as DataTableHeader[];
  }

  get HEADERS() {
    const headers_ = [
      {
        text: this.$t("text.ipAddress"),
        value: "ipAddress",
        class: ["column-sticky", "tw-whitespace-no-wrap"],
        cellClass: ["column-sticky", "tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.controller"),
        value: "controller",
        class: ["column-sticky", "tw-whitespace-no-wrap"],
        cellClass: ["column-sticky", "tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.variableName"),
        value: "variableName",
        class: ["column-sticky", "tw-whitespace-no-wrap"],
        cellClass: ["column-sticky", "tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.controllerVariableMemory"),
        value: "memory",
        class: ["column-sticky", "tw-whitespace-no-wrap"],
        cellClass: ["column-sticky", "tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.type"),
        value: "type",
        class: ["column-sticky", "tw-whitespace-no-wrap"],
        cellClass: ["column-sticky", "tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.unit"),
        value: "unit",
        class: ["column-sticky", "tw-whitespace-no-wrap"],
        cellClass: ["column-sticky", "tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.icon"),
        value: "icon",
        class: ["column-sticky", "tw-whitespace-no-wrap"],
        cellClass: ["column-sticky", "tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.recommendedActions"),
        value: "recommendedAction",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      ...this.CHECKBOXES,
      {
        text: this.$t("text.action"),
        value: "action",
        align: "start",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
    ] as DataTableHeader[];
    if (this.$store.getters.user.organization === "CLIENT") {
      this.lodash.remove(headers_, (val) => val.value === "action");
    } else {
      if ((this as any).$hasPermission({
        context: 'VARIABLES_MANAGEMENT',
        action: 'delete',
      })) {
        headers_.push({ text: '', value: 'data-table-select' });
      }
    }
    return headers_;
  }

  get ROW_PER_PAGES() {
    return this.$util.getConfig().settings.rowPerPage;
  }

  async created() {
    const { id, unitId } = this.$route.params;
    const rs = await Promise.all([
      new LocationsApi().getLocationById({ id }),
      new UnitsApi().getUnitById({ id: unitId }),
    ]);
    if (rs && rs.length > 0) {
      this.getLocationResponse = rs[0].data;
      this.getUnitResponse = rs[1].data;
      let _title =
        this.getUnitResponse.data.name + "'s " + this.$t(`text.variables`);
      if (this.$store.getters.locale === "vi") {
        _title =
          this.$t(`text.parameterOfUnit`) +
          " " +
          this.getUnitResponse.data.name;
      }
      this.$store.commit("SET_BREADCUMB", {
        title: _title,
      });
    }
  }

  mounted() {
    const btn = document.querySelector(
      ".button-unit-add-variable"
    ) as HTMLButtonElement;
    if (btn) {
      btn.onclick = () => {
        this.showVariableDetailDialog = true;
        this.mode = ACTION.NEW_VARIABLE;
      };
    }
  }

  updated() {
    this.$nextTick(() => {
      const variable_container = document.querySelector(".variable-container");
      const search_form = document.querySelector(".search-form");
      // const css_variable_container = window.getComputedStyle(variable_container);
      // const css_search_form = window.getComputedStyle(search_form);
      const table_wrapper = document.querySelector(
        ".variable-table div.v-data-table__wrapper"
      ) as HTMLDivElement;
      table_wrapper.style.maxHeight = `${
        variable_container.clientHeight - search_form.clientHeight - 64 - 60 - 5
      }px`;
    });

    const tableThs: any = document.querySelectorAll(
      ".variable-table table thead tr th"
    );
    this.$nextTick(() => {
      const leftPxArr = [];
      for (let idx = 0; idx <= 6; idx++) {
        const headTh: any = document.querySelector(
          `table > thead > tr > th:nth-child(${idx + 2})`
        );
        const bodyTds: any = (numb) =>
          document.querySelectorAll(
            `table > tbody > tr > td:nth-child(${numb})`
          );
        leftPxArr.push(tableThs[idx].getBoundingClientRect().width);
        const leftPx = leftPxArr.reduce(
          (previousValue, currentValue) => previousValue + currentValue,
          0
        );
        if (headTh) {
          headTh.style.left = leftPx + "px";
          // headTh.style.backgroundColor = `rgb(254 254 254)`;
        }
        const bodyTs2 = bodyTds(idx + 2);
        if (bodyTs2) {
          bodyTs2.forEach((td) => {
            td.style.left = leftPx + "px";
          });
        }
      }
    });
  }

  getRowClass(item: VariableModel) {
    return item && this.selectedRow && item.id === this.selectedRow.id
      ? "row-selected"
      : "";
  }

  onClickRow(item: VariableModel) {
    this.selectedRow = item;
  }

  onEdit(item: VariableModel) {
    this.selectedVariable = item;
    this.mode = ACTION.EDIT_VARIABLE;
    this.showEditVariableDialog = true;
  }

  onRemove(item: VariableModel) {
    this.selectedVariable = item;
    this.showDeleteVariableDialog = true;
  }

  async onSwap() {
    if (this.selectedVariables.length != 2){
      return;
    }
    const item1 = this.selectedVariables[0];
    const item2 = this.selectedVariables[1];
    this.$util.showLoading();
    try {
      await new UnitsApi().updateSortOrderUnitVariable({
        id: this.$route.params.unitId,
        putSortVariableRequest: {
          data: [
            {
              variableId: item1.id,
              sortOrder: item2.sortOrder,
            },
            {
              variableId: item2.id,
              sortOrder: item1.sortOrder,
            },
          ],
        },
      });
      this.doSearch();
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async onMoveUp(item: VariableModel, index: number) {
    const currentIndex = this.lodash.findIndex(this.variables, { id: item.id });
    if (currentIndex <= 0) {
      return;
    }
    const itemBefore = this.variables[currentIndex - 1];
    this.$util.showLoading();
    try {
      await new UnitsApi().updateSortOrderUnitVariable({
        id: this.$route.params.unitId,
        putSortVariableRequest: {
          data: [
            {
              variableId: item.id,
              sortOrder: itemBefore.sortOrder,
            },
            {
              variableId: itemBefore.id,
              sortOrder: item.sortOrder,
            },
          ],
        },
      });
      this.doSearch();
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async onMoveDown(item: VariableModel, index: number) {
    const currentIndex = this.lodash.findIndex(this.variables, { id: item.id });
    if (currentIndex >= this.variables.length - 1) {
      return;
    }
    const itemAfter = this.variables[currentIndex + 1];
    this.$util.showLoading();
    try {
      await new UnitsApi().updateSortOrderUnitVariable({
        id: this.$route.params.unitId,
        putSortVariableRequest: {
          data: [
            {
              variableId: item.id,
              sortOrder: itemAfter.sortOrder,
            },
            {
              variableId: itemAfter.id,
              sortOrder: item.sortOrder,
            },
          ],
        },
      });
      this.doSearch();
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  checkStatusAction() {
    return this.actions.filter((val) => val.action);
  }

  onViewRecommendedAction(selectedVariable) {
    this.showRecommendedAction = true;
    this.selectedVariable = selectedVariable;
  }

  async onOkConfirmDeleteVariableDialog() {
    this.$util.showLoading();
    try {
      if (this.selectedVariables.length > 0) {
        await new VariablesApi().deleteUnitVariables({ variables: this.selectedVariables.map(v=> v.id) });
      } else {
        await new VariablesApi().deleteUnitVariable({
          id: this.selectedVariable.id,
        });
      }
      this.doSearch();
      this.showDeleteVariableDialog = false;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  onPagingOption() {
    this.doSearch();
  }

  async doSearch() {
    this.$util.showLoading();
    const { unitId } = this.$route.params;
    this.selectedVariables= [];
    try {
      const rs = await new VariablesApi().getVariablesByTypeKeyword({
        orderBy: "sortOrder",
        orderDesc: "false",
        page: this.pagingOption.page,
        limit: this.pagingOption.itemsPerPage,
        unitId: unitId,
        type: this.searchForm.type || "",
        keyword: this.searchForm.keyword || "",
      });
      this.totalItems = rs.data.count;
      this.variables = rs.data.data;
      // this.
      // this.variables = this.lodash.sortBy(
      //   rs.data.data,
      //   (item) => item.sortOrder
      // );
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }
}
